// packages/frontend/src/features/imports/addRecipeOptions.ts
//
// Single source of truth for the "how do you want to add this recipe?" option
// list — consumed by both the deep-link fallback page (`routes/recipes/
// NewDispatch.tsx`) and the bottom-sheet quick-capture entry point
// (`AddRecipeSheet.tsx`). Keeping the option data and the key→route mapping
// here means neither surface can drift from the other.

export interface AddRecipeOption {
  key: "url" | "text" | "manual" | "photo";
  icon: string;
  title: string;
  subtitle: string;
}

export const ADD_RECIPE_OPTIONS: AddRecipeOption[] = [
  {
    key: "url",
    icon: "🔗",
    title: "Import from URL",
    subtitle: "Paste a recipe link — we extract the details.",
  },
  {
    key: "text",
    icon: "📋",
    title: "Paste recipe text",
    subtitle: "Paste copied text — we'll parse it.",
  },
  {
    key: "manual",
    icon: "✍️",
    title: "Type from scratch",
    subtitle: "Start with an empty editor.",
  },
  {
    key: "photo",
    icon: "📷",
    title: "From photo",
    subtitle: "Photograph a cookbook recipe — we extract it.",
  },
];

/** Resolves an option key to the route it dispatches to. */
export function addRecipeTarget(key: AddRecipeOption["key"]): string {
  switch (key) {
    case "url":
    case "text":
      return `/imports/new?from=${key}`;
    case "photo":
      // Photo runs the vision-extraction flow (Slice D), not a manual cover.
      return "/imports/photo";
    case "manual":
      // manual lands in the existing recipe editor's draft flow (Plan 04/05).
      return `/recipes/new/draft?from=${key}`;
  }
}
